import { createBasicSelectors } from 'modules/utils/helpers/createBasicSelectors'

const IncentiveProgramSelectors = createBasicSelectors('incentiveProgram')

export default IncentiveProgramSelectors
